let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jdSNM")).then(() => parcelRequire('dqR1S'));